<template>
  <div class="advertising">
    <div class="btn_box">
      <div class="add_btn" @click="add_advertisng(false)">
        <van-icon name="plus" />
        <span>添加新广告</span>
      </div>
    </div>
    <div class="ul">
      <div class="ul_top">选择已有的广告</div>
      <van-list
        class="list"
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="item"
          @click="select(item)"
          v-for="(item, index) in videoList"
          :key="index"
        >
          <div class="item_top">
            <div class="item_left">
              <img :src="item.ad_image" alt="" />
            </div>
            <div class="item_right">
              <div class="title van-multi-ellipsis--l2">
                {{ item.ad_name }}
              </div>
              <div class="dec van-multi-ellipsis--l2">
                {{ item.ad_describe }}
              </div>
            </div>
          </div>
          <div class="item_bottom">
            <van-tag
              plain
              size="large"
              color="#ff410a"
              style="margin-right:.1rem;"
              @click.stop="add_advertisng(item)"
              >修改</van-tag
            >
            <van-tag
              plain
              size="large"
              color="#ff410a"
              @click.stop="delect(item)"
              >删除</van-tag
            >
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { Toast, Dialog, Loading, Field, Icon, List, Tag } from "vant";
import {
  getShare,
  getVideoAdNew,
  getUploadImageNew,
  getAdVideoListNew,
  getDelVideoAdNew
} from "@api/public";
import { cookie } from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
let vm = null;
export default {
  name: "guanggaoAdd",
  components: {
    [Loading.name]: Loading,
    [Icon.name]: Icon,
    [List.name]: List,
    [Tag.name]: Tag,
    [Field.name]: Field,
    [Dialog.confirm.name]: Dialog.confirm
  },
  props: {},
  data: function() {
    return {
      key: "",
      videoList: "",
      error: false,
      loading: false,
      finished: false,
      popshow: true,
      id: ""
    };
  },
  mounted: function() {
    this.key = this.$route.query.secret_key;
    this.id = this.$route.query.id;
  },
  methods: {
    /**
     * 获取视频广告列表
     */
    onLoad() {
      const that = this;
      getAdVideoListNew()
        .then(res => {
          this.videoList = res.data;
          that.loading = false;
          that.finished = true;
        })
        .catch(err => {
          that.loading = false;
          that.finished = true;
        });
    },
    /**
     * 添加广告
     */
    add_advertisng(item) {
      if (item != false) {
        this.$router.push({
          path: "/guanggao/add",
          query: {
            secret_key: this.key,
            id: this.id,
            item: JSON.stringify(item)
          }
        });
      } else {
        this.$router.push({
          path: "/guanggao/add",
          query: {
            secret_key: this.key,
            id: this.id
          }
        });
      }
    },
    /**
     * 删除广告模板
     */
    delect(item) {
      getDelVideoAdNew({ id: item.id })
        .then(res => {
          Toast({ message: res.msg });
          this.onLoad();
        })
        .catch(err => {
          Toast({ message: err.msg });
        });
    },
    /**
     * 选择广告
     */
    select(item) {
      console.log(item);
      getVideoAdNew({
        ad_name: item.ad_name,
        ad_image: item.ad_image,
        ad_describe: item.ad_describe,
        video_url: item.video_url,
        ad_id: item.id,
        secret_key: this.key
      })
        .then(res => {
          Toast({ message: res.msg });
          this.$router.push({
            path: "/video/index",
            query: {
              id: this.id
            }
          });
        })
        .catch(err => {
          Toast({ message: err.msg });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.advertising {
  .btn_box {
    background: #ffffff;
    padding: 0.3rem;
    .add_btn {
      background: #ff410a;
      height: 0.8rem;
      text-align: center;
      font-size: 0.32rem;
      font-weight: bold;
      line-height: 0.8rem;
      color: #ffffff;
    }
  }
  .ul {
    .ul_top {
      background: #fff;
      padding: 0.3rem;
      font-size: 0.4rem;
      font-weight: bold;
      border-bottom: 0.01rem solid #f5f5f5;
    }
    .list {
      .item {
        background: #ffffff;
        margin-top: 0.2rem;
        padding: 0.3rem;
        &:first-child {
          margin-top: 0;
        }
        .item_top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .item_left {
            width: 1.2rem;
            height: 1.2rem;
            font-size: 0;
            border-radius: 0.06rem;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .item_right {
            width: calc(100% - 1.2rem);
            padding-left: 0.2rem;
            .title {
              font-size: 0.32rem;
              font-weight: bold;
              line-height: 0.5rem;
            }
            .dec {
              color: #999999;
            }
          }
        }
        .item_bottom {
          padding-top: 0.2rem;
        }
      }
    }
  }
}
</style>
